// extracted by mini-css-extract-plugin
export default {"container":"styles_container__m-tFU","image":"styles_image__yKi3o","loader":"styles_loader__4laSW","loading":"styles_loading__mvV5P"};